import { Toast } from "vant"
import { getUserInfoFromLocal } from './token'
import  collect  from './collect'
/**
 * 获取当前运行环境，包括：iOS、Android、Chrome 模拟器、微信等
 * @return {}
 */
export const getEnvInfo = () => {
  let system = {
    win: false,
    mac: false,
    x11: false,
    iOS: false,
    android: false,
    wechat: false,
    ali:false
  }
  const p = navigator.platform
  system.win = p.indexOf('Win') === 0
  system.mac = p.indexOf('Mac') === 0 || p.indexOf('mac') === 0
  system.x11 = p === 'X11' || p.indexOf('Linux') === 0
  system.iOS = p.indexOf('iP') === 0
  const ua = navigator.userAgent.toLowerCase()
  system.android = ua.indexOf('android') > -1
  system.wechat = ua.indexOf('micromessenger') !== -1
  system.ali = ua.indexOf('aliapp') !== -1
  return system
}

const getEnvInfoStr = () => {
  let system = getEnvInfo()
  if (system.wechat) {
    return 'WeChat'
  } else if (system.iOS) {
    return 'iOS'
  } else if (system.android && !system.win && !system.mac) {
    return 'Android'
  } else if (system.win || system.mac || system.x11) {
    return 'Simulator'
  } else if(system.ali){
    return 'ali'
  } else {
    return 'Unknown Device'
  }
}

export const envInfo = getEnvInfoStr()

export const appVersionGraterThan = function (androidVersion, iOSVersion) {
  let system = getEnvInfo()
  if (system.iOS || system.android) {
    let ua = navigator.userAgent
    let re = /\/[^ ]*/
    let version = String(ua.match(re)).substring(1)
    // console.log(androidVersion)
    // console.log(iOSVersion)
    if (system.android) {
      let vers = version.split('.')
      let localV = parseInt(vers[0]) * 10000 + parseInt(vers[1]) * 100 + parseInt(vers[2])
      let ches = androidVersion.split('.')
      let checkV = parseInt(ches[0]) * 10000 + parseInt(ches[1]) * 100 + parseInt(ches[2])
      return localV > checkV
    }
    return parseInt(version) > parseInt(iOSVersion)
  }
  return false
}

export let backApp = (data) => {
  var platform = getEnvInfoStr()
  if (data) {
    if (platform === 'iOS') {
      window.webkit.messageHandlers.backPressed.postMessage(data)
    } else if (platform === 'Android') {
      window.AnalyticsClickListener.backPressed(JSON.stringify(data))
    } else {
      Toast('不支持当前运行环境')
    }
    return
  }
  if (platform === 'iOS') {
    window.webkit.messageHandlers.backPressed.postMessage({})
  } else if (platform === 'Android') {
    window.AnalyticsClickListener.backPressed()
  } else {
    Toast('不支持当前运行环境')
  }
}

/**
 * 跟app交互 跳转地址
 */
export let redirectApp = (data) => {
  var platform = getEnvInfoStr()
  if (platform === 'iOS') {
    window.webkit.messageHandlers.switchToView.postMessage(data)
  } else if (platform === 'Android') {
    window.AnalyticsClickListener.postSwitchToView(JSON.stringify(data))
  } else {
    Toast('不支持当前运行环境')
  }
}

/**
 * 获取当前链接中包含的参数
 * @return {}
 */
export const getQuery = () => {
  let url = location.search
  let query = new Object()
  if (url.indexOf('?') !== -1) {
    let str = url.substr(1)
    let strs = str.split('&')
    for (let i = 0; i < strs.length; i++) {
      query[strs[i].split('=')[0]] = unescape(strs[i].split('=')[1])
    }
  }
  return query
}

export const fix = (num, n) => {
  return (Array(n).join(0) + num).slice(-n)
}

/**
 * 打开备孕教练 IM 页面，渠道：十月必怀
 */
export const tenMonthPregnant = () => {
  var platform = getEnvInfoStr()
  if (platform === 'iOS') {
    window.webkit.messageHandlers.talkToCoach.postMessage({
      type: 'tenMonthPregnant'
    })
  } else if (platform === 'Android') {
    window.AnalyticsClickListener.coachPregnancy()
  }
}

export const coachPregnancy = (channel) => {
  if (!channel) {
    channel = ''
  }
  var platform = getEnvInfoStr()
  if (platform === 'iOS') {
    window.webkit.messageHandlers.talkToCoach.postMessage({
      type: channel
    })
  } else if (platform === 'Android') {
    window.AnalyticsClickListener.coachPregnancy()
  } else {
    Toast('不支持当前运行环境')
  }
}

/**
 * 打开 mpId 对应小程序的 path 页面
 */
export const openMNP = (mpId, path) => {
  let params = {
    mpId,
    path
  }
  let system = getEnvInfoStr()
  if (system === 'iOS') {
    window.webkit.messageHandlers.openCSQRCode.postMessage(params)
  } else if (system === 'Android') {
    window.AnalyticsClickListener.openCSQRCode(JSON.stringify(params))
  } else {
    Toast('不支持当前运行环境')
  }
}

const getCSQRCodeParams = (groupName, imgUrl, mnpPath, bgImgUrl, bottomImgUrl, backgroundColor, endBackgroundColor, from, fromDesc, type, pushId, groupContent, style, liveDate) => {
  let mPath = mnpPath || 'pages/csqrcode/main'
  let path = `${mPath}?page_title=${encodeURI(groupName)}&group_name=${encodeURI(groupName)}&img_url=${encodeURI(imgUrl)}`
  if (bgImgUrl) {
    path += `&bg_img_url=${encodeURI(bgImgUrl)}`
  }
  if (bottomImgUrl) {
    path += `&bottom_img_url=${encodeURI(bottomImgUrl)}`
  }
  if (backgroundColor) {
    path += `&background_color=${encodeURI(backgroundColor)}`
  }
  if (endBackgroundColor) {
    path += `&end_background_color=${encodeURI(endBackgroundColor)}`
  }
  if (from) {
    path += `&from=${encodeURI(from)}`
  }
  if (fromDesc) {
    path += `&from_desc=${encodeURI(fromDesc)}`
  }
  if (type) {
    path += `&type=${encodeURI(type)}`
  }
  if (pushId) {
    path += `&push_id=${encodeURI(pushId)}`
  }
  if (groupContent) {
    path += `&page_content=${encodeURI(groupContent)}`
  }
  if (style && style.length > 0) {
    path += `&style=${encodeURI(style)}`
  }
  if (liveDate) {
    path += `&live_date=${encodeURI(liveDate)}`
  }
  return {
    path: path
  }
}

/**
 * 打开小程序“客服”二维码页面，进入“引导加群”等流程
 */
export const openCSQRCode = (groupName, imgUrl, mnpPath, bgImgUrl, bottomImgUrl, backgroundColor, endBackgroundColor, from, fromDesc, type, pushId, groupContent, style, liveDate) => {
  let params = getCSQRCodeParams(groupName, imgUrl, mnpPath, bgImgUrl, bottomImgUrl, backgroundColor, endBackgroundColor, from, fromDesc, type, pushId, groupContent, style, liveDate)
  console.log(decodeURIComponent(params.path))
  let system = getEnvInfoStr()
  if (system === 'iOS') {
    window.webkit.messageHandlers.openCSQRCode.postMessage(params)
  } else if (system === 'Android') {
    window.AnalyticsClickListener.openCSQRCode(JSON.stringify(params))
  } else {
    Toast('不支持当前运行环境')
  }
}

/**
 * 打开小程序“客服”二维码页面，进入“引导加群”等流程。需要 App 端限制 “用户已绑定微信”
 */
export const openCSQRCodeWithUnionId = (groupName, imgUrl, mnpPath, bgImgUrl, bottomImgUrl, backgroundColor, endBackgroundColor, from, fromDesc, type, pushId, groupContent, style, liveDate) => {
  let token = getUserInfoFromLocal().authToken 
  collect.track(token, type)
  console.log(token, type)
  let params = getCSQRCodeParams(groupName, imgUrl, mnpPath, bgImgUrl, bottomImgUrl, backgroundColor, endBackgroundColor, from, fromDesc, type, pushId, groupContent, style, liveDate)
  let system = getEnvInfoStr()
  if (system === 'iOS') {
    window.webkit.messageHandlers.openCSQRCodeWithUnionId.postMessage(params)
  } else if (system === 'Android') {
    window.AnalyticsClickListener.openCSQRCodeWithUnionId(JSON.stringify(params))
  } else {
    Toast('不支持当前运行环境')
  }
}

export const openPregnantMaster = (param) => {
  let system = getEnvInfoStr()
  if (system === 'iOS') {
    if (window.webkit.messageHandlers.callPregnancyMaster) {
      window.webkit.messageHandlers.callPregnancyMaster.postMessage(param)
      return
    }
  } else if (system === 'Android') {
    if (window.AnalyticsClickListener.callPregnancyMaster) {
      window.AnalyticsClickListener.callPregnancyMaster(JSON.stringify(param))
      return
    }
  }
  Toast('不支持当前运行环境')
}

export const openPregnantIn9CyclesHelper = (groupName, imgUrl, bgImgUrl, pushId) => {
  let backgroundColor = ''
  let endBackgroundColor = ''
  let from = ''
  let fromDesc = ''
  let type = 'pregnant_in_9_cycles'
  openCSQRCodeWithUnionId(
    groupName,
    imgUrl,
    '/paper/pages/csqrcode/main',
    bgImgUrl,
    '',
    backgroundColor,
    endBackgroundColor,
    from,
    fromDesc,
    type,
    pushId
  )
}

export const openPregnantMaster1v1 = () => {
  // https://yunchengfile.oss-cn-beijing.aliyuncs.com/cutom/8945f98b-6d61-4473-bbc5-17b9d46836e1_bdhm.png
  // https://yunchengfile.oss-cn-beijing.aliyuncs.com/cutom/df606536-8c61-44f8-a044-5fe3c6529761_chengguo_contact_qr.jpg
  let path = '/paper/pages/csqrcode/main'
  let imgUrl = 'https://yunchengfile.oss-cn-beijing.aliyuncs.com/cutom/8945f98b-6d61-4473-bbc5-17b9d46836e1_bdhm.png'
  let bgImgUrl = 'https://yunchengfile.oss-cn-beijing.aliyuncs.com/cutom/da0d9d83-d968-4487-9982-13ca8995057a_pregnant_master_1v1_pic.png'
  let bottomImgUrl = 'https://yunchengfile.oss-cn-beijing.aliyuncs.com/cutom/98b460dc-0742-46fb-b2d7-9116dfb939e6_pregnancy_group_pic_02.png'
  let backgroundColor = '#FF5D81'
  let endBackgroundColor = '#FF8960'
  let groupName = '1对1专属优孕师'
  let from = 'pregnant_master_1v1'
  let fromDesc = '1对1专属优孕师'
  let type = 'test_temp_plan'
  openCSQRCodeWithUnionId(
    groupName,
    imgUrl,
    path,
    bgImgUrl,
    bottomImgUrl,
    backgroundColor,
    endBackgroundColor,
    from,
    fromDesc,
    type
  )
}
export const openPregnantMaster1v1ByType = (source) => {
  let path = '/paper/pages/csqrcode/main'
  let imgUrl = 'https://yunchengfile.oss-cn-beijing.aliyuncs.com/cutom/8945f98b-6d61-4473-bbc5-17b9d46836e1_bdhm.png'
  let bgImgUrl = 'https://yunchengfile.oss-cn-beijing.aliyuncs.com/cutom/da0d9d83-d968-4487-9982-13ca8995057a_pregnant_master_1v1_pic.png'
  let bottomImgUrl = 'https://yunchengfile.oss-cn-beijing.aliyuncs.com/cutom/98b460dc-0742-46fb-b2d7-9116dfb939e6_pregnancy_group_pic_02.png'
  let backgroundColor = '#FF5D81'
  let endBackgroundColor = '#FF8960'
  let groupName = '1对1专属优孕师'
  let from = 'pregnant_master_1v1'
  let fromDesc = '1对1专属优孕师'
  let type = source
  openCSQRCodeWithUnionId(
    groupName,
    imgUrl,
    path,
    bgImgUrl,
    bottomImgUrl,
    backgroundColor,
    endBackgroundColor,
    from,
    fromDesc,
    type
  )
}
export const openPregnantMaster1v1ByTypeAndImg = (source, bg) => {
  let path = '/paper/pages/csqrcode/main'
  let imgUrl = 'https://yunchengfile.oss-cn-beijing.aliyuncs.com/cutom/8945f98b-6d61-4473-bbc5-17b9d46836e1_bdhm.png'
  let bgImgUrl = bg
  let bottomImgUrl = 'https://yunchengfile.oss-cn-beijing.aliyuncs.com/cutom/98b460dc-0742-46fb-b2d7-9116dfb939e6_pregnancy_group_pic_02.png'
  let backgroundColor = '#AFD0F9'
  let endBackgroundColor = '#AFD0F9'
  let groupName = '1对1专属优孕师'
  let from = 'pregnant_master_1v1'
  let fromDesc = '1对1专属优孕师'
  let type = source
  openCSQRCodeWithUnionId(
    groupName,
    imgUrl,
    path,
    bgImgUrl,
    bottomImgUrl,
    backgroundColor,
    endBackgroundColor,
    from,
    fromDesc,
    type
  )
}

export const getImUrl = () => {
  let imUrl
  if (process.env.VUE_APP_MODE === 'production') {
    imUrl = 'https://static.shecarefertility.com/shecare/im/dist/index.html#/Customer'
  } else {
    imUrl = 'https://static.shecarefertility.com/shecare/test/im/dist/index.html#/Customer'
  }
  return imUrl
}

export const getParameterByName = (name, url) => {
  if (!url) url = window.location.href
  // eslint-disable-next-line
  name = name.replace(/[\[\]]/g, '\\$&')
  var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)')
  var results = regex.exec(url)
  if (!results) return null
  if (!results[2]) return ''
  return decodeURIComponent(results[2].replace(/\+/g, ' '))
}


export const getShopUrl = () => {
  let shopUrl
  if (process.env.VUE_APP_MODE === 'production') {
    shopUrl = 'https://wechat.shecarefertility.com/dist/index.html#/'
  } else {
    shopUrl = 'https://testwechat.shecarefertility.com/dist/index.html#/'
  }
  return shopUrl
}
/**
 * 胎心仪领券链接
 */
export const getFhTaobaoUrl = () => {
  return 'https://s.click.taobao.com/t?e=m%3D2%26s%3Dc42T4HomnQ1w4vFB6t2Z2ueEDrYVVa64MljcGUdc4HdyINtkUhsv0OZ5IvM2yL0i1se3LAEPWtu%2BHlSBfzQfjB9U4xE7dJ0UepxfL%2FZ1pjbgTpFp96EEgtNwpZG%2B6czZlntEOsmn00xRRjj7xTWTDTtpW1MrBCbF%2BPCIsfLymVY7NOeHsw%2BU4hobOVMJch%2BOvG%2BAKzSJliRe1kKCfSHLn1FtH8SBlAfzsnUZLubS18lZQnypmklpz%2ByJOddZw1BRxgxdTc00KD8%3D&union_lens=lensId%3APUB%401683535164%4021086e37_0a21_187fa83f2f2_a46f%4001%40eyJmbG9vcklkIjo2MTQyOSwiic3BtQiiI6Il9wb3J0YWxfdjJfcGFnZXNfcHJvbW9fZ29vZHNfZGV0YWlsX2h0bSJ9'
}
/**
 * 有赞商品path
 */
export const yzPaths = () => {
  return {
    // ht: 'pages/common/blank-page/index?scene=906136275',//红妥
    ht:'pages/common/blank-page/index?scene=1094495787',//红妥无货备用
    htbl: 'pages/common/blank-page/index?scene=1089389237',//红妥伴侣
    lt: 'pages/common/blank-page/index?scene=1089389707',//绿妥
    tj: 'pages/common/blank-page/index?scene=1089389845',//妥金
    tjbl: 'pages/common/blank-page/index?scene=906138044',//妥金伴侣
    pjb: 'pages/common/blank-page/index?scene=1089390199',//好孕泡脚包
    hcgBox: 'pages/common/blank-page/index?scene=1249783760',//HCG翻倍监测仪下线  换成多联卡
    //hcgMulCard: 'pages/common/blank-page/index?scene=1089394335',//半定量HCG试纸
    hcgMulCard: 'pages/common/blank-page/index?scene=1249783760',//半定量HCG试纸 美丽泰格
    // fh: 'pages/common/blank-page/index?scene=906241277'//胎心仪
    // fh: 'pages/common/blank-page/index?scene=1492696815',//胎心仪
    fh: 'pages/common/blank-page/index?scene=1113503444',
    fhrm: 'pages/common/blank-page/index?scene=1291081498',
    hyn:'packages/goods/detail/index?alias=2786yfo00aa7z1e&shopAutoEnter=1',
    hcg:'pages/common/blank-page/index?scene=1504096997'
  }
}
export const goBuyUtil = (good) =>{
  if(good === 'hcg'){
    openMNP('gh_6e51874b9360', yzPaths().hcg)
  }
}
/**
 * 打开浏览器
 */
export let redirectBrowser = (taobaoUrl, taobaoUrlIos) => {
  if (!taobaoUrlIos) {
    taobaoUrlIos = taobaoUrl
  }
  var system = getEnvInfoStr()
  if (system === 'WeChat') {
    window.open(taobaoUrl)
  } else if (system === 'iOS') {
    window.webkit.messageHandlers.openOutsideUrl.postMessage({
      redirectUrl: taobaoUrlIos
    })
  } else if (system === 'Android') {
    window.AnalyticsClickListener.openOutsideUrl(taobaoUrl)
  } else {
    window.open(taobaoUrl)
  }
}
export const openDepositAlipay = (param) => {
  let system = getEnvInfoStr()
  if (system === 'iOS') {
    if (window.webkit.messageHandlers.openDepositAlipay) {
      window.webkit.messageHandlers.openDepositAlipay.postMessage(param)
      return
    }
  } else if (system === 'Android') {
    if (window.AnalyticsClickListener.openDepositAlipay) {
      window.AnalyticsClickListener.openDepositAlipay(JSON.stringify(param))
      return
    }
  }
  Toast('不支持当前运行环境')
}